import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EEcologyRatingActionTypes {
  SetRating = 'NEW_REVIEW/ECOLOGY_RATING/SET',
}

export type TSetEcologyRating = ITypedReduxAction<EEcologyRatingActionTypes.SetRating, number>;

/**
 * Redux action, который записывает в store общий рейтинг экологии нового отзыва
 * @param rating number
 */
export const setEcologyRating: (rating: number) => TSetEcologyRating = actionGenerator<
  EEcologyRatingActionTypes.SetRating,
  number
>(EEcologyRatingActionTypes.SetRating);
